/** @jsx jsx */
import { jsx } from "theme-ui";

import { ActionButton } from "office-ui-fabric-react";
import PropTypes from "prop-types";

const AbhyasiEntity = ({ abhyasiId, display }) => {
  return (
    <ActionButton
      iconProps={{ iconName: "IdBadge" }}
      text={display || abhyasiId}
    />
  );
};

AbhyasiEntity.propTypes = {
  abhyasiId: PropTypes.string.isRequired,
  display: PropTypes.string,
};

AbhyasiEntity.defaultProps = {
  display: "",
};

export default AbhyasiEntity;
